import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

// src/api/assemblyAI.ts
export const getAssemblyAIToken = async (): Promise<string> => {
    const getToken = httpsCallable(functions, "getAssemblyAIToken");
    const result = await getToken();
    const data = result.data as { token: string };
    return data.token;
};
